<script>
    import MainContainer from "./MainContainer.svelte"
    import TicketList from "./TicketList.svelte";
    
    let ticketsSize = 0

</script>

<MainContainer>
    <h4>Active tickets ({ticketsSize})</h4>

    <TicketList bind:ticketsSize/>
</MainContainer>